import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Login from "./pages/Login/Login";
import { CreateUserPage } from "./pages/CreateUserPage";
import AdminHome from "./pages/User/AdminHome";
import UserFiles from "./pages/User/UserFiles";
import NavBar from "./components/NavBar";
import UserEdit from "./pages/User/UserEdit";
import UserHome from "./pages/User/UserHome";
import FilePage from "./pages/FilePage";

const App = () => {
  return (
    <>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/home" element={<Navigate to="/" replace />} />

          <Route path="/admin-home">
            <Route index element={<AdminHome />} />
            <Route path="users" element={<AdminHome activeKey="users" />} />
            <Route path="users/new" element={<CreateUserPage />} />
            <Route path="files" element={<AdminHome activeKey="files" />} />
            <Route
              path="app-versions"
              element={<AdminHome activeKey="app-versions" />}
            />
            <Route
              path="firmware-versions"
              element={<AdminHome activeKey="firmware-versions" />}
            />
          </Route>

          <Route path="/user-files/:userId?" element={<UserFiles />} />
          <Route path="/edit-user/:userId" element={<UserEdit />} />
          <Route path="/user-home" element={<UserHome />} />

          <Route path="/files/:fileName" element={<FilePage />} />
        </Routes>
      </Router>
      <ToastContainer />
    </>
  );
};

export default App;
